import React, { useEffect, useState } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import {
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  Row,
  Col,
  Container,
  Input,
  Table,
  FormGroup,
  NavLink as TabLink,
} from "reactstrap";
import classnames from "classnames";
import Switch from "react-switch";
import DataTable from "react-data-table-component";

//assets
import toggleOpen from "../../../assets/image/toogle-open.png";
import toggleClose from "../../../assets/image/toggle-off.png";
import plus from "../../../assets/image/icons/plus.svg";
import { requestApi } from "../../../request-api";
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { dataToXLS } from "../../../helpers/dataToXLS";

//tippy package for tooltip
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

function Legislation() {
  let [currentActiveTab, setCurrentActiveTab] = useState("1");
  let [isChecked, setIsChecked] = useState(false);
  let [checked, setChecked] = useState(false);
  const [complianceOfficer, setComplianceOfficer] = useState([]);
  const [complianceOfficerFilter, setComplianceOfficerFilter] = useState([]);
  const [approverFilter, setApproverFilter] = useState([]);
  const [company, setCompany] = useState([]);
  const [searchComp, setSearchComp] = useState("");
  const [searchApprover, setSearchApprover] = useState("");
  const [filteredSearch, setFilteredSearch] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [companyCount, setCompanyCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [searchStatusApprover, setSearchStatusApprover] = useState("");
  const [searchStatusComp, setSearchStatusComp] = useState("");
  let [report, setReport] = useState([]);
  let [companyFilter, setCompanyFilter] = useState([]);
  let [branchFilter, setBranchFilter] = useState([]);
  let [reportFilter, setReportFilter] = useState([]);
  let [downloadData, setDownloadData] = useState([]);
  let [searchApproverStatusComp, setSearchApproverStatusComp] = useState([]);
  let searchCompanyName = [];
  let searchCompanyNameApprover = [];

  let [companyNameSearch, setCompanyNameSearch] = useState([]);
  let [companyNameSearchApprover, setCompanyNameSearchApprover] = useState([]);

  const [pagination, setPagination] = useState({
    skip: 0,
    limit: 500000,
  });

  const onChangeCompliaceOfficer = (e, id) => {
    let status = "";
    if (e === true) {
      status = 1;
    } else {
      status = 0;
    }
    requestApi(`/userRole/userActiveStatus/${id}/${status}`, {
      method: "get",
    })
      .then((response) => {
        if (response.statusCode == 200) {
          onGetApprover();
          onGetComplianceOfficer();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const downloadReport = () => {
    dataToXLS(downloadData, "Compliance Officer list");
  };
  const downloadReport2 = () => {
    dataToXLS(downloadData, "Approver list");
  };

  const onChangeApprover = (e, id) => {
    let status = "";
    if (e === true) {
      status = 1;
    } else {
      status = 0;
    }
    requestApi(`/userRole/userActiveStatus/${id}/${status}`, {
      method: "get",
    })
      .then((response) => {
        if (response.statusCode == 200) {
          onGetApprover();
          onGetComplianceOfficer();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    onGetComplianceOfficer();
    // onGetApprover();
  }, [pagination]);

  // const onGetComplianceOfficer = () => {

  //   requestApi('/auditor/getComplianceofficer', {
  //     method: 'get',
  //   }).then(async (data) => {
  //     console.log("Compliancer data", data)
  //     setFiltered(data.data)
  //     data.data.forEach(compliancer => {
  //       console.log("compliancer")
  //       requestApi('/auditor/compliance/getCompanyAssigned', {
  //         method: 'post',
  //         body: JSON.stringify({
  //           compliance_officer_id: compliancer.id
  //         })
  //       }).then((de) => {
  //         console.log(de)
  //         let compList = []
  //         let comCompany = []
  //         let comBranch = []
  //         // setFiltered(data.data)

  //         de.data.map((compData) => {
  //           if (!comCompany.find((name) => { return name == compData.company_name })) {

  //             comCompany.push(compData.company_name);
  //           }

  //           comBranch.push(compData.branch_id)
  //         })
  //         let joined = compliancer.created_at.split('T')[0]
  //         let detail = {
  //             id:compliancer.id,
  //             status:compliancer.status,
  //             name:compliancer.name,
  //             company:comCompany,
  //             branch:comBranch,
  //             phone:compliancer.phone_number,
  //             joined:joined
  //         }
  //         setComplianceOfficer(complianceOfficer => complianceOfficer.concat(detail))

  //     })

  //    });
  //     } ).catch(error =>{
  //       console.log(error)
  //   });
  //   }

  const onGetComplianceOfficer = () => {
    requestApi("/auditor/getComplianceofficer", {
      method: "get",
    }).then(async (data) => {
      console.log("Compliance officer", data);
      if (data.statusCode === 200) {
        console.log("data of compliance code>>", data);

        setComplianceOfficer(data.data);
        console.log("complianceOfficer", data.data.length);

        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].company.includes(",")) {
            let split_compnay_name = data.data[i].company.split(",");
            split_compnay_name.map((comp) => {
              searchCompanyName.push(comp);
            });
            console.log("data.data[i].company");
          } else {
            searchCompanyName.push(data.data[i].company);
          }
        }
        setCompanyNameSearch(
          searchCompanyName.filter(
            (type, index) => searchCompanyName.indexOf(type) === index
          )
        );
        setComplianceOfficerFilter(data.data);
      }
    });
  };

  const tableCustomStyles = {
    headCells: {
      style: {
        backgroundColor: "#F0F0F0",
      },
    },
  };
  //Compliance Officer
  const [column, setColumn] = useState([
    {
      name: "Sr No",
      cell: (row, index) => index + 1,
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="bs-form">
          <FormGroup switch>
            <Input
              type="switch"
              role="switch"
              checked={row.status == 1 ? true : false}
              onChange={(e) => {
                console.log("value of", e.target.checked, row.id);
                onChangeCompliaceOfficer(e.target.checked, row.id);
              }}
            />
          </FormGroup>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Name",
      selector: (row) => <td>{row.name} &nbsp; </td>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Company Name",
      selector: (row) => <td>{row.company} &nbsp; </td>,
      sortable: true,
      width: "200px",
    },
    {
      name: "Contact Number",
      selector: (row) => <td>{row.phone} &nbsp; </td>,
      sortable: true,
      width: "150px",
    },

    {
      name: "Branched covered",
      selector: (row) => (
        //   <Tippy
        //   class={"bs-tooltip"}
        //   content={row.branch}
        //   className={"bs-tooltip"}
        //   html={<div className="bs-tooltip ">{row.branch} &nbsp;</div>}
        // >
        //    <td className="block-ellipsis">{row.branch} &nbsp; </td>
        // </Tippy>
     
        // <Tippy style={{ backgroundColor: "white" }} content={row.branch}>
          <td className="block-ellipsis">{row.branch} &nbsp; </td>
        // </Tippy>
      ),
      sortable: true,
    },
    {
      name: "Joined On",
      selector: (row) => <td>{row.joined} &nbsp; </td>,
      sortable: true,
      width: "150px",
    },
    // &&(alert("Thank you, to connect with us."),window.location.href="contact-us")
    {
      name: "Latest Activity",
      selector: (row) => <td>&nbsp;{"Updated"}</td>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      grow: 2,
      selector: (row) => (
        <td>
          <NavLink
            className="text-decoration-none"
            to={`${directUrl}auditor/complaincer-officer/${row.id}`}
          >
            <i className="icon icon-edit-new"></i>
          </NavLink>
        </td>
      ),
    },
  ]);

  //Approver Table
  const [columns, setColumns] = useState([
    {
      name: "Sr No",
      cell: (row, index) => index + 1,
      sortable: true,
      width: "100px",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <td>
          <div className="bs-form">
            <FormGroup switch>
              <Input
                type="switch"
                role="switch"
                checked={row.status == 1 ? true : false}
                onChange={(e) => {
                  console.log("value of", e.target.checked);
                  onChangeApprover(e.target.checked, row.id);
                }}
              />
            </FormGroup>
          </div>
        </td>
      ),
      sortable: true,
    },

    {
      name: "Name",
      selector: (row) => <td>{row.name} &nbsp; </td>,
      sortable: true,
    },
    {
      name: "Company Name",
      selector: (row) => <td>{row.company_name} &nbsp; </td>,
      sortable: true,
    },
    {
      name: "Contact Number",
      selector: (row) => <td>{row.phone_number} &nbsp; </td>,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => <td>{row.office_address} &nbsp; </td>,
      sortable: true,
    },
    {
      name: "Branched covered",
      selector: (row) => (
        <td className="block-ellipsis">{row.branch_id} &nbsp; </td>
        // <Tippy
        //   class={"bs-tooltip"}
        //   content={row.branch_id}
        //   className={"bs-tooltip"}
        //   html={<div className="bs-tooltip">{row.branch_id} &nbsp;</div>}
        // >
        //   <td className="block-ellipsis">{row.branch_id} &nbsp;</td>
        // </Tippy>
      ),

      sortable: true,
    },
    {
      name: "Joined On",
      selector: (row) => <td>{row.DOJ} &nbsp; </td>,
      sortable: true,
    },
    // &&(alert("Thank you, to connect with us."),window.location.href="contact-us")
    {
      name: "Latest Activity",
      selector: (row) => <td>&nbsp;{"Updated"}</td>,
      sortable: true,
    },
    {
      name: "Action",
      grow: 2,
      selector: (row) => (
        <td>
          <NavLink
            className="text-decoration-none"
            to={`${directUrl}auditor/approver/${row.id}`}
          >
            <i className="icon icon-edit-new"></i>
          </NavLink>
        </td>
      ),
    },
  ]);

  const navigate = useNavigate();
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const handleChange = (checked) => {
    setChecked(checked);
  };
  const routeChange = (path) => {
    navigate(path);
  };

  const routeChangeToCreateCompliancer = () => {
    navigate(`${directUrl}auditor/create-user-profile/complaincer-officer`);
  };

  const routeChangeToCreateApprover = () => {
    navigate(`${directUrl}auditor/create-user-profile/approver`);
  };

  useEffect(() => {
    if (searchComp === "empty") {
      return setComplianceOfficerFilter(complianceOfficer);
    }
    const result = complianceOfficer.filter((comp) => {
      return (
        comp.name.toLowerCase().match(searchComp.toLowerCase()) ||
        comp.company.toLowerCase().match(searchComp.toLowerCase()) ||
        comp.phone.toLowerCase().match(searchComp.toLowerCase()) ||
        comp.branch.toLowerCase().match(searchComp.toLowerCase())
      );
    });
    setComplianceOfficerFilter(result);
  }, [searchComp]);

  useEffect(() => {
    if (searchStatusComp === "empty") {
      return setComplianceOfficerFilter(complianceOfficer);
    }
    const result = complianceOfficer.filter((comp) => {
      return comp.status == searchStatusComp;
    });
    setComplianceOfficerFilter(result);
  }, [searchStatusComp]);

  useEffect(() => {
    if (searchApprover === "empty") {
      return setApproverFilter(filteredSearch);
    }
    const result = filteredSearch.filter((comp) => {
      return (
        comp.name.toLowerCase().match(searchApprover.toLowerCase()) ||
        comp.company_name.toLowerCase().match(searchApprover.toLowerCase()) ||
        comp.phone_number.toLowerCase().match(searchApprover.toLowerCase())
      );
    });
    setApproverFilter(result);
  }, [searchApprover]);

  useEffect(() => {
    if (searchApproverStatusComp === "empty") {
      return setApproverFilter(filteredSearch);
    }
    const result = filteredSearch.filter((comp) => {
      return comp.status == searchApproverStatusComp;
    });
    setApproverFilter(result);
  }, [searchApproverStatusComp]);

  const dummy = (e) => {
    console.log(e);
    if (e.allSelected == true) {
      let id = 0;
      for (let i = 0; i < e.selectedRows.length; i++) {
        id = id + 1;
        e.selectedRows[i].id = id;
      }
      setDownloadData(e.selectedRows);
    } else if (e.allSelected == false && e.selectedCount == 0) {
      setDownloadData([]);
    } else if (e.selectedCount > 0) {
      let id = 0;
      for (let i = 0; i < e.selectedRows.length; i++) {
        id = id + 1;
        e.selectedRows[i].id = id;
      }
      setDownloadData(e.selectedRows);
    } else if (e.selectedCount == 0) {
      setDownloadData([]);
    }
    if (e.selectedCount == 0) {
      setIsChecked(false);
    } else {
      setIsChecked(true);
    }
  };
  const dummy2 = (e) => {
    console.log(e);
    if (e.allSelected == true) {
      let id = 0;
      for (let i = 0; i < e.selectedRows.length; i++) {
        id = id + 1;
        e.selectedRows[i].id = id;
      }
      setDownloadData(e.selectedRows);
    } else if (e.allSelected == false && e.selectedCount == 0) {
      setDownloadData([]);
    } else if (e.selectedCount > 0) {
      let id = 0;
      for (let i = 0; i < e.selectedRows.length; i++) {
        id = id + 1;
        e.selectedRows[i].id = id;
      }
      setDownloadData(e.selectedRows);
    } else if (e.selectedCount == 0) {
      setDownloadData([]);
    }
    if (e.selectedCount == 0) {
      setIsChecked(false);
    } else {
      setIsChecked(true);
    }
  };

  const onGetApprover = () => {
    requestApi("/auditor/approver/getAllApprover", {
      method: "get",
      //   body:JSON.stringify({
      //     skip:pagination.skip,
      //     limit:pagination.limit
      // })
    }).then(async (data) => {
      console.log("Approver data", data);
      if (data.statusCode === 200) {
        console.log("data status code>>", data);
        let compN = [];
        let compId = [];
        let compDate = [];
        let branchId = [];

        setCompany(data.data);
        setCompanyCount(data.data.length);
        setApproverFilter(data.data);
        setFilteredSearch(data.data);
        setCompanyName(
          data.data.map((cn) => {
            return cn.company_name;
          })
        );
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].company_name.includes(",")) {
            let split_compnay_name = data.data[i].company_name.split(",");
            split_compnay_name.map((comp) => {
              searchCompanyNameApprover.push(comp);
            });
          } else {
            searchCompanyNameApprover.push(data.data[i].company_name);
          }
        }
        setCompanyNameSearchApprover(
          searchCompanyNameApprover.filter(
            (type, index) => searchCompanyNameApprover.indexOf(type) === index
          )
        );
        setComplianceOfficerFilter(data.data);

        data.data.map((c) => {
          if (!compN.find((cn) => cn === c.company_name)) {
            compN.push(c.company_name);
          }
          if (!compId.find((cn) => cn === c.company_id)) {
            compId.push(c.company_id);
          }
          if (!compDate.find((cn) => cn === c.date_of_mou)) {
            compDate.push(c.date_of_mou);
          }
          setCompanyName(compN);
          // setDate(compDate)
        });
        // console.log("data.data",companyName);
      }
    });
  };

  let compCount = 0;
  let approverCount = 0;
  return (
    <main>
      <section className="lyt-section">
        <Container fluid className="typ-container">
          <div className="bs-card">
            <Row>
              {isChecked ? (
                currentActiveTab === "1" ? (
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="bs-action-btn">
                      <div className="button-group">
                        <a
                          className="action-btn"
                          onClick={(e) => {
                            downloadReport();
                          }}
                        >
                          {" "}
                          <span class="icon icon-download"></span>
                        </a>
                        {/* <a className="action-btn" href="">
                        {' '}
                        <span class="icon icon-share"></span>
                      </a>
                      <a className="action-btn" href="">
                        <span class="icon icon-delete"></span>
                      </a> */}
                      </div>
                    </div>
                  </Col>
                ) : (
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="bs-action-btn">
                      <div className="button-group">
                        <a
                          className="action-btn"
                          onClick={(e) => {
                            downloadReport2();
                          }}
                        >
                          {" "}
                          <span class="icon icon-download"></span>
                        </a>
                        {/* <a className="action-btn" href="">
                        {' '}
                        <span class="icon icon-share"></span>
                      </a>
                      <a className="action-btn" href="">
                        <span class="icon icon-delete"></span>
                      </a> */}
                      </div>
                    </div>
                  </Col>
                )
              ) : (
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="bs-table ">
                    <div className="main-header">
                      {currentActiveTab === "1" ? (
                        <form className="bs-form">
                          <div className="search-btn">
                            <Input
                              type="search"
                              placeholder="Search...."
                              onChange={(e) => {
                                setSearchComp(e.target.value);
                              }}
                            />
                            <i className="icon icon-search"></i>
                          </div>
                          <div className="dropdown-bx">
                            <label className="form-label">
                              Company Name :{" "}
                            </label>
                            <Input
                              type="select"
                              name="select"
                              id="exampleSelect"
                              onChange={(e) => {
                                setSearchComp(e.target.value);
                              }}
                            >
                              <option value={"empty"}>Select</option>
                              {companyNameSearch.map((comp) => {
                                return (
                                  comp != "" && (
                                    <option key={comp} value={comp}>
                                      {comp}
                                    </option>
                                  )
                                );
                              })}
                              {/* {complianceOfficer.map((companyCount) => {
                                let company = companyCount.company.split(',');
                                   return company.map((comp) => {
                                  // console.log("compliance compnay name",comp.filter((type, index) =>  comp.indexOf(type) === index  ));
                                  return ( 
                                     comp != '' &&  
                                    <option key={comp} value={comp}>
                                      {comp}                                     
                                    </option>
                                  );
                                });
                              })} */}
                            </Input>
                          </div>
                          <div className="dropdown-bx">
                            <label className="form-label">Status : </label>
                            <Input
                              type="select"
                              name="select"
                              id="exampleSelect"
                              onChange={(e) => {
                                setSearchStatusComp(e.target.value);
                              }}
                            >
                              <option value={"empty"}>Select</option>
                              <option key={"0"} value={"0"}>
                                Inactive
                              </option>
                              <option key={"1"} value={"1"}>
                                Active
                              </option>
                            </Input>
                          </div>
                        </form>
                      ) : (
                        <form className="bs-form">
                          <div className="search-btn">
                            <Input
                              type="text"
                              placeholder="Search..."
                              onChange={(e) => {
                                setSearchApprover(e.target.value);
                              }}
                            />
                            <i className="icon icon-search"></i>
                          </div>
                          <div className="dropdown-bx">
                            <label className="form-label">
                              Company Name :{" "}
                            </label>
                            <Input
                              onChange={(e) => {
                                setSearchApprover(e.target.value);
                              }}
                              type="select"
                              name="select"
                              id="exampleSelect"
                            >
                              <option value={"empty"}>Select</option>
                              {companyNameSearchApprover.map((comp) => {
                                return (
                                  comp != "" && (
                                    <option key={comp} value={comp}>
                                      {comp}
                                    </option>
                                  )
                                );
                              })}
                              {/* {filteredSearch.map((companyCount) => (
                                <option
                                  key={companyCount.company_name}
                                  value={companyCount.company_name}
                                >
                                  {companyCount.company_name}
                                </option>
                              ))} */}
                            </Input>
                          </div>
                          <div className="dropdown-bx">
                            <label className="form-label">Status : </label>
                            <Input
                              onChange={(e) => {
                                setSearchApproverStatusComp(e.target.value);
                              }}
                              type="select"
                              name="select"
                              id="exampleSelect"
                            >
                              <option value={"empty"}>Select</option>
                              <option key={"0"} value={"0"}>
                                Inactive
                              </option>
                              <option key={"1"} value={"1"}>
                                Active
                              </option>
                            </Input>
                          </div>
                        </form>
                      )}

                      {currentActiveTab === "1" ? (
                        <div className="left-button">
                          <button
                            className="bs-btn btn-submit typ-create"
                            onClick={routeChangeToCreateCompliancer}
                          >
                            <span class="icon icon-plus"></span> CREATE
                            COMPLIANCER
                          </button>
                        </div>
                      ) : currentActiveTab === "2" ? (
                        <div className="left-button">
                          <button
                            className="bs-btn btn-submit typ-create"
                            onClick={routeChangeToCreateApprover}
                          >
                            <span class="icon icon-plus"></span> CREATE APPROVER
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Col>
              )}
              <div className="bs-tabs">
                <Nav tabs>
                  <NavItem>
                    <TabLink
                      className={classnames({
                        active: currentActiveTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                        onGetComplianceOfficer();
                      }}
                    >
                      Compliance Officer
                    </TabLink>
                  </NavItem>
                  <NavItem>
                    <TabLink
                      className={classnames({
                        active: currentActiveTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                        onGetApprover();
                      }}
                    >
                      Approver
                    </TabLink>
                  </NavItem>
                </Nav>
              </div>
              <TabContent activeTab={currentActiveTab}>
                <TabPane tabId="1">
                  <div className="bs-table border">
                    <div className="bs-table typ-datable overflow-on">
                      <DataTable
                        columns={column}
                        data={complianceOfficerFilter}
                        customStyles={tableCustomStyles}
                        pagination
                        fixedHeader
                        fixedHeaderScrollHeight="450px"
                        selectableRows
                        onSelectedRowsChange={dummy}
                        selectableRowsHighlight
                        highlightOnHover
                      />
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="bs-table typ-datable border">
                    <DataTable
                      columns={columns}
                      data={approverFilter}
                      customStyles={tableCustomStyles}
                      pagination
                      fixedHeader
                      fixedHeaderScrollHeight="450px"
                      selectableRows
                      onSelectedRowsChange={dummy2}
                      selectableRowsHighlight
                      highlightOnHover
                    />
                    {/* <Table responsive>
                      <thead>
                        <tr>
                          <th>
                            <Input type="checkbox" />{' '}
                          </th>
                          <th>Sr.no.</th>
                          <th>Status</th>
                          <th>Officer ID</th>
                          <th>Name </th>
                          <th>Company Name</th>
                          <th>Contact Number</th>
                          <th>Address</th>
                          <th>Branches Covered </th>
                          <th>Joined On</th>
                          <th>Latest Activity</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Input type="checkbox" />{' '}
                          </td>
                          <td>1</td>
                          <td>
                            <Switch
                              onChange={handleChange}
                              checked={checked}
                              uncheckedIcon
                              checkedIcon
                              height={11}
                              width={26}
                              handleDiameter={9}
                              onColor="#F6B737"
                              offColor="#74788D"
                            />
                          </td>
                          <td>xyz_1234567890</td>
                          <td>xyz</td>
                          <td>
                            <NavLink to={``}>HDFC</NavLink>
                          </td>
                          <td>123467890</td>
                          <td>4141 Rockside Rd Suite 410, US</td>
                          <td>
                            <NavLink to={``}>
                              D..TN..Wo.. ,Ku..Si..CST..{' '}
                            </NavLink>
                          </td>
                          <td>01/02/22</td>
                          <td>Commented</td>
                        </tr>
                        <tr>
                          <td>
                            <Input type="checkbox" />{' '}
                          </td>
                          <td>2</td>
                          <td>
                            <Switch
                              onChange={handleChange}
                              checked={checked}
                              uncheckedIcon
                              checkedIcon
                              height={11}
                              width={26}
                              handleDiameter={9}
                              onColor="#F6B737"
                              offColor="#74788D"
                            />
                          </td>
                          <td>xyz_1234567890</td>
                          <td>xyz</td>
                          <td>
                            <NavLink to={``}>HDFC</NavLink>
                          </td>
                          <td>123467890</td>
                          <td>4141 Rockside Rd Suite 410, US</td>
                          <td>
                            <NavLink to={``}>
                              D..TN..Wo.. ,Ku..Si..CST..{' '}
                            </NavLink>
                          </td>
                          <td>01/02/22</td>
                          <td>Audited Branch</td>
                        </tr>
                        <tr>
                          <td>
                            <Input type="checkbox" />{' '}
                          </td>
                          <td>3</td>
                          <td>
                            <Switch
                              onChange={handleChange}
                              checked={checked}
                              uncheckedIcon
                              checkedIcon
                              height={11}
                              width={26}
                              handleDiameter={9}
                              onColor="#F6B737"
                              offColor="#74788D"
                            />
                          </td>
                          <td>xyz_1234567890</td>
                          <td>xyz</td>
                          <td>
                            <NavLink to={``}>HDFC</NavLink>
                          </td>
                          <td>123467890</td>
                          <td>4141 Rockside Rd Suite 410, US</td>
                          <td>
                            <NavLink to={``}>
                              D..TN..Wo.. ,Ku..Si..CST..{' '}
                            </NavLink>
                          </td>
                          <td>01/02/22</td>
                          <td>Audited Branch</td>
                        </tr>
                        <tr>
                          <td>
                            <Input type="checkbox" />{' '}
                          </td>
                          <td>4</td>
                          <td>
                            <Switch
                              onChange={handleChange}
                              checked={checked}
                              uncheckedIcon
                              checkedIcon
                              height={11}
                              width={26}
                              handleDiameter={9}
                              onColor="#F6B737"
                              offColor="#74788D"
                            />
                          </td>
                          <td>xyz_1234567890</td>
                          <td>xyz</td>
                          <td>
                            <NavLink to={``}>HDFC</NavLink>
                          </td>
                          <td>123467890</td>
                          <td>4141 Rockside Rd Suite 410, US</td>
                          <td>
                            <NavLink to={``}>
                              D..TN..Wo.. ,Ku..Si..CST..{' '}
                            </NavLink>
                          </td>
                          <td>01/02/22</td>
                          <td>Audited Branch</td>
                        </tr>
                        <tr>
                          <td>
                            <Input type="checkbox" />{' '}
                          </td>
                          <td>5</td>
                          <td>
                            <Switch
                              onChange={handleChange}
                              checked={checked}
                              uncheckedIcon
                              checkedIcon
                              height={11}
                              width={26}
                              handleDiameter={9}
                              onColor="#F6B737"
                              offColor="#74788D"
                            />
                          </td>
                          <td>xyz_1234567890</td>
                          <td>xyz</td>
                          <td>
                            <NavLink to={``}>HDFC</NavLink>
                          </td>
                          <td>123467890</td>
                          <td>4141 Rockside Rd Suite 410, US</td>
                          <td>
                            <NavLink to={``}>
                              D..TN..Wo.. ,Ku..Si..CST..{' '}
                            </NavLink>{' '}
                          </td>
                          <td>01/02/22</td>
                          <td>Commented</td>
                        </tr>
                      </tbody>
                    </Table> */}
                  </div>
                </TabPane>
              </TabContent>
            </Row>
          </div>
        </Container>
      </section>
    </main>
  );
}

export default Legislation;
